<template>
  <div class="login-box">
    <div class="login-top">
      <div class="inline logo">
        <img src="../assets/logo.png" alt=""/>
      </div>
      <div class="inline go-back" @click="$router.go(-1)">返回</div>
      <span class="inline fr">登陆</span>
    </div>
    <div class="title tc"></div>
    <div class="login-form">
      <el-form :model="loginForm" label-position="left" ref="loginForm" class="demo-loginForm">
        <el-form-item prop="mobile" :rules="[{ required: true, message: '不能为空' }, { pattern: /^1[3456789]\d{9}$/, message: '请输入正确手机号' }]">
          <el-input class="mobileinput" v-model="loginForm.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="password" :rules="{ required: true, message: '不能为空' }">
          <el-input class="passwordinput" show-password v-model="loginForm.password" placeholder="请输入密码" maxlength="200"></el-input>
        </el-form-item>
      </el-form>
      <div class="txt">
        <router-link :to="{path: '/register', query: {device: $route.query.device, hospital: $route.query.hospital}}" class="inline">注册</router-link>
        <router-link :to="{path: '/forget', query: {device: $route.query.device, hospital: $route.query.hospital}}" class="fr">忘记密码？</router-link>
      </div>
      <el-button type="primary" round :loading="btnLoading" @click="handleLogin" class="login-submit yoo-button-1">登录</el-button>
    </div>
  </div>
</template>

<script>
import { login } from '@/api'
export default {
  data () {
    return {
      loginForm: {
        mobile: '',
        password: ''
      },
      btnLoading: false
    }
  },
  methods: {
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.submit()
        }
      })
    },
    submit () {
      this.btnLoading = true
      var formData = new FormData()
      formData.append('mobile', this.loginForm.mobile)
      formData.append('password', this.loginForm.password)
      formData.append('deviceid', this.$route.query.device)
      // formData.append('code', '')
      login(formData).then(res => {
        this.$cookies.set('h5_user', res.data.username)
        this.$cookies.set('h5_token', res.data.token)
        this.$notify.success({
          message: res.msg,
          showClose: false,
          offset: 100,
          duration: 2000
        })
        this.$router.push({path: '/', query: {device: this.$route.query.device, hospital: this.$route.query.hospital}})
      }).finally(() => {
        this.btnLoading = false
      })
    }
  },
  mounted () {
    this.$cookies.remove('n_user')
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/login.vue